import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";

import { Storage } from "aws-amplify";
import axios from "axios";
import { withFormik } from "formik";
import _ from "lodash";
import * as Yup from "yup";

//containers
import AdminWrapper from "../../containers/AdminWrapper";
import ContentWrapper from "../../containers/ContentWrapper";
//actions
import * as dialogActions from "../../redux/actions/dialogactions";
//services
import shotService from "../../services/shotService";
import UploadList from "./UploadList";

import ConfirmationDialog from "./ConfirmationDialog";

//sample image card component
//created a component for easier listening when we delete a sample photo
class SampleImagesCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progress: 0,
      confirmDialog: false,
      isDeleting: false
    };
  }

  onDeleteImage = async () => {
    try {
      console.log("deleteing");
      this.setState({ isDeleting: true });
      this.props.setStateValue({
        isDeleting: true
      });
      await this.props.removeSampleShot(this.props.shot.key);
      console.log("done");
      this.setState({ isDeleting: false });
      this.props.setStateValue({ isDeleting: false });
      await this.props.getPhoto();
    } catch (error) {
      this.setState({ isDeleting: false });
      this.props.setStateValue({ isDeleting: false });
    }
  };

  openConfirmDialog = () => {
    this.setState({ confirmDialog: true });
  };

  onConfirm = () => {
    this.setState({ confirmDialog: false }, () => {
      this.onDeleteImage();
    });
  };

  onCancel = params => this.setState({ confirmDialog: false });

  render() {
    let { shot, index, edit } = this.props;
    return (
      <Paper elevation={1} style={{ padding: 20, margin: "10px 0" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start"
          }}
        >
          <div
            style={{
              minWidth: 130,
              minHeight: 70,
              marginRight: 20,
              backgroundImage: `url(${shot.src})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover"
            }}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "100%"
              }}
            >
              <div>
                <Typography variant="h6">{edit ? shot.name : shot.file.name}</Typography>
                <Typography variant="subtitle1" component="span">
                  {shot.computedSize.toFixed(2) + " " + shot.computedSizeUnit}
                </Typography>
              </div>
              <div style={{ margin: "auto 0" }}>
                {this.state.isDeleting ? (
                  <div style={{ padding: "0 12px" }}>
                    <CircularProgress color="primary" size={20} />
                  </div>
                ) : (
                  <IconButton
                    aria-label="Delete"
                    onClick={() => (edit ? this.openConfirmDialog(index) : this.props.removeSampleImage(index))}
                    disabled={this.props.isDeleting}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </div>
            {
              // shot.uploading ?
              //   <LinearProgress variant="indeterminate" style={{height: 3}} />
              // : null
            }
          </div>
        </div>
        <ConfirmationDialog open={this.state.confirmDialog} onConfirm={this.onConfirm} onCancel={this.onCancel} />
      </Paper>
    );
  }
}

//validation and formik for the shot detail form
class ShotDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validateCalled: false,

      shotTypeLabelWidth: 0,
      categoryLabelWidth: 0,
      cameraLabelWidth: 0
    };
  }

  componentDidMount() {
    if (!this.props.edit) {
      this.setState({
        shotTypeLabelWidth: ReactDOM.findDOMNode(this.shotTypeLabelRef).offsetWidth
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.values.type === "video" && prevState.cameraLabelWidth === 0 && this.state.cameraLabelWidth === 0) {
      console.log("inside the if", ReactDOM.findDOMNode(this.cameraLabelRef).offsetWidth);
      this.setState({
        cameraLabelWidth: ReactDOM.findDOMNode(this.cameraLabelRef).offsetWidth
      });
    }
    if (ReactDOM.findDOMNode(this.shotTypeLabelRef) && prevState.shotTypeLabelWidth === 0 && this.state.shotTypeLabelWidth === 0) {
      this.setState({
        shotTypeLabelWidth: ReactDOM.findDOMNode(this.shotTypeLabelRef).offsetWidth
      });
    }
  }

  uploadFeaturedImage = async id => {
    try {
      this.props.setStateValue({
        sampleFeaturedImage: {
          ...this.props.sampleFeaturedImage,
          uploading: true
        }
      });
      await Storage.put(`photo/${id}/featured.png`, this.props.sampleFeaturedImage.file, {
        contentType: this.props.sampleFeaturedImage.file.type,
        level: "public",
        progressCallback: progress => {
          console.log("Progress: " + (progress.loaded / progress.total) * 100, this.props.sampleFeaturedImage.progress);
          let computedProgress = Math.floor((progress.loaded / progress.total) * 100);
          if (computedProgress >= this.props.sampleFeaturedImage.progress) {
            // console.log(
            //  "Progress: " + Math.floor((progress.loaded / progress.total) * 100)
            // );
            let sampleFeaturedImage = Object.assign({}, this.props.sampleFeaturedImage, { progress: computedProgress });
            this.props.setStateValue({
              sampleFeaturedImage: {
                ...this.props.sampleFeaturedImage,
                progress: computedProgress
              }
            });
          }
        }
      });

      this.props.setStateValue({
        sampleFeaturedImage: null,
        featuredImage: {
          fetching: false,
          src: this.props.sampleFeaturedImage.src
        }
      });
    } catch (err) {
      this.props.setStateValue({
        sampleFeaturedImage: null
      });
    }
  };

  addShot = async () => {
    try {
      this.setState({ validateCalled: true });
      let isValid = await this.props.validateForm();
      console.log(isValid);
      if (this.props.isValid) {
        var shot;
        const { type, angle, camera, description, framing, location, scene, video_url } = this.props.values;
        if (type === "photo") {
          shot = {
            angle,
            description,
            framing,
            location,
            scene,
            type
          };
        } else {
          shot = {
            angle,
            description,
            camera,
            framing,
            location,
            scene,
            type,
            video_url
          };
        }
        console.log(shot);
        if (this.props.edit) {
          this.props.setStateValue({
            savingShot: true
          });
          console.log("update");
          await shotService.updateOneShot(this.props.id, shot, {
            params: {
              scene: this.props.router.location.search.scene
            }
          });

          this.props.setStateValue({
            savingShot: false
          });
          //  this.props.history.push("/shots/" + this.props.shotDetails.type);
          // this.props.history.replace(`/shots/edit/${this.props.match.params.id}?scene=${shot.scene}`)
        } else {
          this.props.setStateValue({
            savingShot: true
          });
          const value = await shotService.saveShot(shot);
          console.log(value);
          this.uploadFeaturedImage(value.data);
          this.props.setStateValue({
            uploadShotSamples: true,
            id: value.data
          });
          if (this.props.shotSamplesLength <= 0) this.props.history.push("/shots/" + type);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  goToPhotoShots = () => {
    this.props.history.push("/shots/photo");
  };

  render() {
    const { validateCalled } = this.state;
    const { handleChange, handleBlur, errors, values, touched, router } = this.props;

    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button variant="outlined" color="primary" onClick={this.goToPhotoShots}>
            Back
          </Button>
          {!this.props.edit && (
            <Button
              variant="contained"
              color="primary"
              onClick={this.addShot}
              disabled={this.props.savingShot || (this.props.edit && this.props.fetching) || this.props.photoListFetching}
            >
              Save Shot
            </Button>
          )}
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
          <Grid xs={12} md={8} item>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="subtitle1" gutterBottom>
                Shot Details
              </Typography>
              {this.props.edit && (
                <Button
                  size="small"
                  color="primary"
                  onClick={this.addShot}
                  disabled={this.props.savingShot || (this.props.edit && this.props.fetching) || this.props.photoListFetching}
                >
                  Save
                </Button>
              )}
            </div>
            {this.props.savingShot || (this.props.edit && this.props.fetching) || this.props.photoListFetching ? (
              <LinearProgress color="primary" style={{ height: 2 }} />
            ) : null}

            {this.props.edit && this.props.fetching ? null : ( // </div> //   /> //     color="primary" //   <CircularProgress // <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Paper style={{ padding: 24, marginTop: 20 }}>
                <Typography variant="subtitle2" gutterBottom>
                  To {this.props.edit ? "edit" : "add"} shot please enter the necessary information. Click "Save" to{" "}
                  {this.props.edit ? "edit" : "add"} shot.
                </Typography>

                {/* Shot type Field */}
                <FormControl variant="outlined" fullWidth style={{ margin: "16px 0 8px 0" }} error={(touched.type || validateCalled) && errors.type}>
                  <InputLabel
                    ref={ref => {
                      this.shotTypeLabelRef = ref;
                    }}
                    htmlFor="outlined-shot-type"
                  >
                    Shot Type
                  </InputLabel>
                  <Select
                    native
                    value={values.type}
                    input={
                      <OutlinedInput
                        labelWidth={this.state.shotTypeLabelWidth}
                        id="outlined-shot-type"
                        id="type"
                        error={(touched.type || validateCalled) && errors.type}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    }
                  >
                    <option value="photo">Photo</option>
                    <option value="video">Video</option>
                  </Select>
                </FormControl>
                <TextField
                  autoComplete="off"
                  id="scene"
                  helperText={(touched.scene || validateCalled) && errors.scene}
                  error={(touched.scene || validateCalled) && errors.scene}
                  value={values.scene}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  label="Scene"
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
                <TextField
                  autoComplete="off"
                  id="description"
                  helperText={(touched.description || validateCalled) && errors.description}
                  error={(touched.description || validateCalled) && errors.description}
                  value={values.description}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  label="Description"
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
                <TextField
                  autoComplete="off"
                  id="location"
                  helperText={(touched.location || validateCalled) && errors.location}
                  error={(touched.location || validateCalled) && errors.location}
                  value={values.location}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  label="Location"
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
                <TextField
                  autoComplete="off"
                  id="angle"
                  helperText={(touched.angle || validateCalled) && errors.angle}
                  error={(touched.angle || validateCalled) && errors.angle}
                  value={values.angle}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  label="Angle"
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
                <TextField
                  autoComplete="off"
                  id="framing"
                  helperText={(touched.framing || validateCalled) && errors.framing}
                  error={(touched.framing || validateCalled) && errors.framing}
                  value={values.framing}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  label="Framing"
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
                {values.type === "video" ? (
                  <>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      style={{ margin: "16px 0 8px 0", position: "relative" }}
                      error={(touched.camera || validateCalled) && errors.camera}
                    >
                      <InputLabel
                        ref={ref => {
                          this.cameraLabelRef = ref;
                        }}
                        htmlFor="outlined-camera"
                      >
                        Camera Movement
                      </InputLabel>
                      <Select
                        native
                        value={values.camera}
                        input={
                          <OutlinedInput
                            labelWidth={this.state.cameraLabelWidth}
                            id="camera"
                            error={(touched.camera || validateCalled) && errors.camera}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        }
                      >
                        <option value="" />
                        <option value="Any">Any</option>
                        <option value="Static">Static</option>
                        <option value="Static or Pan">Static or Pan</option>
                        <option value="Static, Pan or Glide">Static, Pan or Glide</option>
                        <option value="Following">Following</option>
                        <option value="Following or Paning">Following or Paning</option>
                        <option value="Following or Static">Following or Static</option>
                        <option value="Pan or Glide">Pan or Glide</option>
                        <option value="Focus Pull">Focus Pull</option>
                      </Select>
                    </FormControl>
                    <TextField
                      autoComplete="off"
                      id="video_url"
                      helperText={(touched.video_url || validateCalled) && errors.video_url}
                      error={(touched.video_url || validateCalled) && errors.video_url}
                      value={values.video_url}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      label="Video url"
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                  </>
                ) : null}
              </Paper>
            )}
          </Grid>
        </div>
      </div>
    );
  }
}

class AddShot extends Component {
  constructor(props) {
    super(props);
    let edit = props.match.params.id ? true : false;
    let type = props.match.params.type ? props.match.params.type : "";
    this.state = {
      angle: "",
      type: type,
      category: "",
      scene: "",
      location: "",
      description: "",
      framing: "",
      camera: "",
      savingShot: false,
      edit,
      fetching: edit,
      isDeleting: false,
      failed: false,
      shotSamples: [],
      uploadShotSamples: false,
      id: null,
      photoList: {
        data: [],
        fetching: edit
      },
      selectFeature: null,
      featuredImage: {
        fetching: true,
        src: null
      },
      sampleFeaturedImage: null
    };
  }

  setStateValue = value => {
    this.setState(value);
  };

  async componentDidMount() {
    this.getPhoto();
  }

  componentDidUpdate() {
    if (
      this.props.values.type === "photo" &&
      !this.state.edit &&
      this.state.savingShot &&
      this.state.sampleFeaturedImage === null &&
      this.state.shotSamples.length === 0
    ) {
      this.props.history.push("/shots/" + this.props.values.type);
    }
  }

  getPhoto = async () => {
    console.log("sulod");
    if (this.state.edit) {
      let { data } = await shotService.getOneShot(this.props.match.params.id, {
        params: {
          scene: this.props.router.location.search.scene
        }
      });
      console.log(data);
      this.props.setValues(data);
      //  this.props.setFieldValue("location", data.location);
      let shot = Object.assign({}, this.state, data, {
        fetching: false,
        failed: false
      });
      let photoList = this.state.photoList;
      this.setState(shot);

      let photo = await Storage.list(`photo/${this.props.match.params.id}/sample-images`);
      photo = photo.map(photo => {
        let key = photo.key;
        let firstRemove = key.substring(key.indexOf("/") + 1);
        let name = firstRemove.substring(firstRemove.indexOf("/") + 1);

        return {
          ...photo,
          name
        };
      });

      //get the featured image
      let featuredImage = await this.getFeaturedImage(`photo/${this.props.match.params.id}/featured.png`);
      featuredImage = Object.assign(
        {},
        this.state.featuredImage,
        { src: featuredImage },
        {
          fetching: false
        }
      );
      //get the public links
      let photoLinks = await this.getPublicLinks(photo);
      photoList = Object.assign({}, this.state.photoList, {
        fetching: false,
        data: photoLinks
      });
      this.setState({
        photoList,
        featuredImage
      });
    }
  };

  getFeaturedImage = async path => {
    try {
      let featuredImage = await Storage.get(path);
      console.log(`featured`, featuredImage);
      await axios.get(featuredImage);
      return featuredImage;
    } catch (err) {
      console.log(err.message);
      if (err.message === "Request failed with status code 404") {
        return null;
      }
    }
  };

  getPublicLinks = async list => {
    console.log(list[0]);
    let urlList = await Promise.all(
      list.map(item => {
        return Storage.get(item.key);
      })
    );
    let finalList = list.map((item, index) => {
      let computedSize, computedSizeUnit;
      let computedSizeInKB = item.size / 1024;
      let computedSizeInMB = item.size / 1048576;
      let computedSizeInGB = item.size / 1073741824;
      if (item.size > 999 && computedSizeInKB < 1000) {
        computedSize = computedSizeInKB;
        computedSizeUnit = "KB";
      } else if (computedSizeInMB < 1000) {
        computedSize = computedSizeInMB;
        computedSizeUnit = "MB";
      } else {
        computedSize = computedSizeInGB;
        computedSizeUnit = "GB";
      }
      return {
        ...item,
        name: item.name.substring(14),
        src: urlList[index],
        computedSize,
        computedSizeUnit
      };
    });
    return finalList;
  };

  selectFile = () => {
    this.fileInput.click();
  };

  handleSelectFileChange = e => {
    let { files } = this.fileInput;
    let shots = this.state.shotSamples;
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      console.log(element);
      if (!_.find(shots, item => item.file.name === element.name)) {
        let temp = {};
        temp.file = element;
        temp.src = URL.createObjectURL(element);
        temp.finish = false;
        temp.failed = false;
        temp.uploading = false;
        let computedSizeInKB = element.size / 1024;
        let computedSizeInMB = element.size / 1048576;
        let computedSizeInGB = element.size / 1073741824;
        if (element.size > 999 && computedSizeInKB < 1000) {
          temp.computedSize = computedSizeInKB;
          temp.computedSizeUnit = "KB";
        } else if (computedSizeInMB < 1000) {
          temp.computedSize = computedSizeInMB;
          temp.computedSizeUnit = "MB";
        } else {
          temp.computedSize = computedSizeInGB;
          temp.computedSizeUnit = "GB";
        }
        shots.push(temp);
      }
    }
    this.setState({
      shotSamples: shots
    });
    this.fileInput.value = "";
  };

  selectFeature = () => {
    this.featureInput.click();
  };

  handleSelectFeaturedImage = e => {
    let { files } = this.featureInput;
    let file = files[0];
    console.log(file);
    if (file) {
      const element = file;
      console.log(element);
      let temp = {};
      temp.file = element;
      temp.src = URL.createObjectURL(element);
      temp.finish = false;
      temp.failed = false;
      temp.uploading = false;
      let computedSizeInKB = element.size / 1024;
      let computedSizeInMB = element.size / 1048576;
      let computedSizeInGB = element.size / 1073741824;
      if (element.size > 999 && computedSizeInKB < 1000) {
        temp.computedSize = computedSizeInKB;
        temp.computedSizeUnit = "KB";
      } else if (computedSizeInMB < 1000) {
        temp.computedSize = computedSizeInMB;
        temp.computedSizeUnit = "MB";
      } else {
        temp.computedSize = computedSizeInGB;
        temp.computedSizeUnit = "GB";
      }
      temp.progress = 0;
      this.setState({
        sampleFeaturedImage: temp
      });
      this.fileInput.value = "";
    }
  };

  clearFeaturedImage = () => this.setState({ sampleFeaturedImage: null });

  formatFileSize = element => {
    let temp = {};
    temp.file = element;
    temp.src = URL.createObjectURL(element);
    temp.finish = false;
    temp.failed = false;
    temp.uploading = false;
    let computedSizeInKB = element.size / 1024;
    let computedSizeInMB = element.size / 1048576;
    let computedSizeInGB = element.size / 1073741824;
    if (element.size > 999 && computedSizeInKB < 1000) {
      temp.computedSize = computedSizeInKB;
      temp.computedSizeUnit = "KB";
    } else if (computedSizeInMB < 1000) {
      temp.computedSize = computedSizeInMB;
      temp.computedSizeUnit = "MB";
    } else {
      temp.computedSize = computedSizeInGB;
      temp.computedSizeUnit = "GB";
    }
    return temp;
  };

  removeSampleImage = index => {
    let state = this.state;
    let newState = state.shotSamples.splice(index, 1);
    console.log("newState", newState);
    this.setState(newState);
  };

  updateSampleShot = async (index, shot) => {
    let { shotSamples } = this.state;
    shotSamples[index] = shot;

    //check if all photos are done upload
    //check the sample shot in the state if all of them are uploaded
    let done = true;
    for (let shot of this.state.shotSamples) {
      if (shot.finished) {
        done = true;
      } else if (shot.failed || shot.uploading) {
        done = false;
        break;
      }
    }
    console.log(done);
    if (done) {
      this.setState({ shotSamples: [], uploadShotSamples: false }, () => {
        this.getPhoto();
      });
    } else {
      this.setState({
        shotSamples
      });
    }
  };

  uploadSampleImages = () => {
    this.setState(
      {
        uploadShotSamples: true
      },
      () => {
        if (this.state.edit && this.state.shotSamples.length < 0) this.setState({ uploadShotSamples: false });
      }
    );
  };

  uploadFeaturedImage = id => {
    this.setState({
      sampleFeaturedImage: {
        ...this.state.sampleFeaturedImage,
        uploading: true
      }
    });
    // if (!id) {
    //  id = this.props.match.params.id;
    // }
    if (this.state.edit) {
      id = this.props.match.params.id;
    }
    console.log("id of shot", id, this.props.match.params.id);
    Storage.put(`photo/${id}/featured.png`, this.state.sampleFeaturedImage.file, {
      contentType: this.state.sampleFeaturedImage.file.type,
      level: "public",
      progressCallback: progress => {
        //  console.log("Progress: " + (progress.loaded / progress.total) * 100, this.state.sampleFeaturedImage.progress);
        let computedProgress = Math.floor((progress.loaded / progress.total) * 100);
        if (computedProgress >= this.state.sampleFeaturedImage.progress) {
          // console.log(
          //  "Progress: " + Math.floor((progress.loaded / progress.total) * 100)
          // );
          let sampleFeaturedImage = Object.assign({}, this.state.sampleFeaturedImage, { progress: computedProgress });
          this.setState({
            sampleFeaturedImage: {
              ...this.state.sampleFeaturedImage,
              progress: computedProgress
            }
          });
        }
      }
    })
      .then(async result => {
        let featuredImage = await this.getFeaturedImage(`photo/${this.props.match.params.id}/featured.png`);
        featuredImage = Object.assign(
          {},
          this.state.featuredImage,
          { src: featuredImage },
          {
            fetching: false
          }
        );
        console.log(featuredImage);
        this.setState({ featuredImage, sampleFeaturedImage: null });
      })
      .catch(err => console.log(err));
  };

  removeSampleShot = key => {
    return Storage.remove(key);
  };

  render() {
    let featuredImageSrc = null;
    let featuredImage = null;
    if (this.state.sampleFeaturedImage) {
      featuredImageSrc = this.state.sampleFeaturedImage.src;
      featuredImage = (
        <div style={{ position: "relative" }}>
          {this.state.sampleFeaturedImage.uploading && (
            <div
              style={{
                display: "flex",
                position: "absolute",
                height: "100%",
                width: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <CircularProgress size={80} variant="static" value={this.state.sampleFeaturedImage.progress} />
            </div>
          )}
          <Fab size="small" color="primary" aria-label="add" style={{ position: "absolute", top: -20, right: -20 }} onClick={this.clearFeaturedImage}>
            <CloseIcon fontSize="small" color="inherit" />
          </Fab>
          <img src={featuredImageSrc} style={{ maxWidth: "600px" }} />
        </div>
      );
    } else {
      featuredImageSrc = this.state.featuredImage.src;
      featuredImage = <img src={featuredImageSrc} style={{ maxWidth: "600px" }} />;
    }

    if (this.props.match.params.type === "photo" || this.props.values.type === "photo"){
      console.log(this.props.match.params.type, this.props.values.type)
    }
      console.log(this.props.match.params.type === "photo" || this.props.values.type === "photo");
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title={`${this.state.edit ? "Edit" : "Create"} Shot`} hasPadding>
          {/* ShotDetails */}
          <ShotDetails
            shotDetails={{
              angle: this.state.angle,
              type: this.state.type,
              scene: this.state.scene,
              location: this.state.location,
              description: this.state.description,
              framing: this.state.framing,
              camera: this.state.camera
            }}
            id={this.state.id}
            setStateValue={this.setStateValue}
            edit={this.state.edit}
            fetching={this.state.fetching}
            failed={this.state.failed}
            photoListFetching={this.state.photoList.fetching}
            savingShot={this.state.savingShot}
            shotSamplesLength={this.state.shotSamples.length}
            sampleFeaturedImage={this.state.sampleFeaturedImage}
            uploadFeaturedImage={this.uploadFeaturedImage}
            {...this.props}
          />
          {/* Shot Details */}

          {((this.props.match.params.type === "photo" || this.props.values.type === "photo") && !this.state.fetching) && (
            <>
              {/* Featured Images */}
              <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
                <Grid xs={12} md={8} item>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Featured Image
                    </Typography>
                    <input
                      type="file"
                      ref={element => (this.featureInput = element)}
                      style={{ display: "none" }}
                      accept="image/png, image/jpeg, .jpg"
                      onChange={this.handleSelectFeaturedImage}
                    />
                    <div>
                      {this.state.edit && (
                        <Button
                          color="primary"
                          onClick={this.uploadFeaturedImage}
                          style={{ marginRight: 5 }}
                          disabled={!Boolean(this.state.sampleFeaturedImage)}
                        >
                          Upload
                        </Button>
                      )}
                      <Button color="primary" onClick={this.selectFeature} style={{ marginLeft: 5 }}>
                        {this.state.edit ? "Choose Photo" : "Add"}
                      </Button>
                    </div>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    {(this.state.edit && this.state.featuredImage.fetching) ||
                    (this.state.featuredImage.src !== null || this.state.sampleFeaturedImage) ? (
                      <div style={{ display: "flex", justifyContent: "center" }}>{featuredImage}</div>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          flex: 1,
                          padding: "20px 0"
                        }}
                      >
                        <AddPhotoAlternateIcon style={{ fontSize: 120 }} color="primary" />
                        <Typography variant="h6" style={{ color: "rgba(0,0,0,0.5)" }}>
                          No featured image
                        </Typography>
                      </div>
                    )}
                  </div>
                </Grid>
              </div>
              {/* Featured Images */}

              {/* Sample Images */}
              <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
                <Grid xs={12} md={8} item>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Sample Images
                    </Typography>
                    <input
                      type="file"
                      ref={element => (this.fileInput = element)}
                      style={{ display: "none" }}
                      multiple
                      accept="image/png, image/jpeg, .jpg"
                      onChange={this.handleSelectFileChange}
                    />
                    <div>
                      {this.state.edit && (
                        <Button
                          color="primary"
                          onClick={this.uploadSampleImages}
                          style={{ marginRight: 5 }}
                          disabled={this.state.shotSamples.length === 0}
                        >
                          Upload
                        </Button>
                      )}
                      <Button color="primary" onClick={this.selectFile} style={{ marginLeft: 5 }}>
                        {this.state.edit ? "Choose Photo" : "Add"}
                      </Button>
                    </div>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <React.Fragment>
                      {this.state.shotSamples.length > 0 && (
                        <Typography variant="subtitle2" gutterBottom>
                          Pending uploads
                        </Typography>
                      )}
                      {//component for uploading
                      //and representation
                      this.state.uploadShotSamples
                        ? this.state.shotSamples.map((shot, index) => {
                            return (
                              <UploadList
                                shot={shot}
                                key={index}
                                id={this.state.id}
                                type={this.state.type}
                                updateSampleShot={this.updateSampleShot}
                              />
                            );
                          })
                        : this.state.shotSamples.map((shot, index) => {
                            return <SampleImagesCard shot={shot} key={index} removeSampleImage={this.removeSampleImage} />;
                          })}
                    </React.Fragment>
                    {this.state.edit && !this.state.photoList.fetching && (
                      <Typography variant="subtitle2" gutterBottom>
                        Uploaded images
                      </Typography>
                    )}
                    {(this.state.edit && this.state.photoList.fetching) ||
                    (this.state.photoList.data.length > 0 || this.state.shotSamples.length > 0) ? (
                      this.state.photoList.data.map((shot, index) => {
                        return (
                          <SampleImagesCard
                            edit={this.state.edit}
                            shot={shot}
                            key={index}
                            removeSampleImage={this.removeSampleImage}
                            removeSampleShot={this.removeSampleShot}
                            setStateValue={this.setStateValue}
                            isDeleting={this.state.isDeleting}
                            getPhoto={this.getPhoto}
                          />
                        );
                      })
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          flex: 1,
                          padding: "20px 0"
                        }}
                      >
                        <Typography variant="h6" style={{ color: "rgba(0,0,0,0.5)" }}>
                          No sample images
                        </Typography>
                      </div>
                    )}
                  </div>
                </Grid>
              </div>
              {/* Sample Images */}
            </>
          )}
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}

const WithFormikShotDetails = withFormik({
  mapPropsToValues: props => {
    // console.log(props);
    let shot = props.shotDetails;
    return {
      angle: "",
      type: "photo",
      scene: "",
      location: "",
      description: "",
      framing: "",
      camera: "",
      video_url: ""
    };
  },
  validationSchema: Yup.object().shape({
    angle: Yup.string().required("Angle field is required."),
    type: Yup.string().required("Type field is required."),
    scene: Yup.string()
      .matches(/^(\b[A-Z]\w*\s*)+$/, "First letter of every word must be a capital letter.")
      .required("Scene field is required."),
    location: Yup.string().required("Location field is required."),
    description: Yup.string().required("Description field is required."),
    framing: Yup.string().required("Framing field is required."),
    camera: Yup.string().when("type", (type, schema) => {
      return type === "video" ? schema.required("Camera Movement field is required.") : schema.notRequired();
    }),
  }),
  validateOnChange: true,
   enableReinitialize: true,
  isInitialValid: false
})(AddShot);

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed,
    router: state.router
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithFormikShotDetails);
